import { CustomElement } from '../types';

export const serializeToMarkdown = (nodes: CustomElement[]): string => {
  // TODO: Implement Markdown serialization
  console.log('Serialize to Markdown:', nodes);
  return '# Markdown serialization not implemented yet';
}; 